/**
 * Arabic profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Arabic
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 105
 */

export const AR = {
  "metadata": {
    "name": "Arabic",
    "code": "ar",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 105
  },
  "words": [
    {
      "word": "عبد",
      "severity": 4,
      "categories": [
        "hate_speech",
        "racist",
        "extremely_offensive"
      ],
      "variations": [
        "عبد",
        "abd",
        "3abd"
      ],
      "case_sensitive": false,
      "context_notes": "Nigger - extremely racist slur, absolutely forbidden. Arabizi: 3abd",
      "target_type": "individual"
    },
    {
      "word": "ارذلي زبي يا قحبة",
      "severity": 4,
      "categories": [
        "sexual",
        "command",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "ارذلي زبي يا قحبة",
        "arthali zebbi ya ka7ba"
      ],
      "case_sensitive": false,
      "context_notes": "Suck my dick bitch - Tunisian extremely vulgar sexual command. Arabizi: arthali zebbi ya ka7ba",
      "target_type": "individual"
    },
    {
      "word": "اصبع على صرمك",
      "severity": 4,
      "categories": [
        "sexual",
        "command",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "اصبع على صرمك",
        "asba3 ala sormek"
      ],
      "case_sensitive": false,
      "context_notes": "Get a penis on your hole - Tunisian extremely vulgar sexual insult. Arabizi: asba3 ala sormek",
      "target_type": "individual"
    },
    {
      "word": "عيره فيك",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar"
      ],
      "variations": [
        "عيره فيك",
        "ayreh feek",
        "3ayre feek"
      ],
      "case_sensitive": false,
      "context_notes": "My penis in you - extremely vulgar Levantine insult. Arabizi: 3ayre feek",
      "target_type": "individual"
    },
    {
      "word": "برا نايك",
      "severity": 4,
      "categories": [
        "sexual",
        "command",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "برا نايك",
        "bara nayek",
        "bara naik"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you - Tunisian extremely vulgar sexual command. Arabizi: bara nayek",
      "target_type": "individual"
    },
    {
      "word": "برانك",
      "severity": 4,
      "categories": [
        "sexual",
        "command",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "برانك",
        "baranek",
        "baranik"
      ],
      "case_sensitive": false,
      "context_notes": "Go fuck yourself - Tunisian extremely vulgar command. Arabizi: baranek",
      "target_type": "individual"
    },
    {
      "word": "شرموطا",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "extremely_vulgar"
      ],
      "variations": [
        "شرموطا",
        "charmouta",
        "shar6a",
        "sharmouta"
      ],
      "case_sensitive": false,
      "context_notes": "Slut (variant spelling) - extremely offensive term for women. Arabizi: shar6a",
      "target_type": "individual"
    },
    {
      "word": "فشخ",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "egyptian_specific"
      ],
      "variations": [
        "فشخ",
        "fashkh",
        "fash5"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking - extremely vulgar sexual term, Egyptian. Arabizi: fash5",
      "target_type": "general"
    },
    {
      "word": "هدبحك",
      "severity": 4,
      "categories": [
        "threat",
        "violence",
        "egyptian_specific"
      ],
      "variations": [
        "هدبحك",
        "hadba7ak",
        "hadba7ak"
      ],
      "case_sensitive": false,
      "context_notes": "I'll kill you - violent threat, extremely serious. Arabizi: hadba7ak",
      "target_type": "individual"
    },
    {
      "word": "هنيكك",
      "severity": 4,
      "categories": [
        "sexual",
        "threat",
        "extremely_vulgar"
      ],
      "variations": [
        "هنيكك",
        "haneikak",
        "haneek",
        "7aneekak"
      ],
      "case_sensitive": false,
      "context_notes": "I will fuck you - sexual threat, extremely vulgar. Arabizi: 7aneekak",
      "target_type": "individual"
    },
    {
      "word": "هوي موك",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "maghrebi_specific"
      ],
      "variations": [
        "هوي موك",
        "hwi muk",
        "hwi mouk"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - Moroccan extremely offensive family/sexual insult. Arabizi: hwi mouk",
      "target_type": "individual"
    },
    {
      "word": "ابن الاهبة",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "ابن الاهبة",
        "ibn el ahba",
        "ebn el a7ba"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a prostitute - extremely offensive family insult. Arabizi: ebn el a7ba",
      "target_type": "individual"
    },
    {
      "word": "جعب",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "جعب",
        "ja3b",
        "je3b"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina - Tunisian extremely vulgar anatomical term. Arabizi: je3b",
      "target_type": "general"
    },
    {
      "word": "قهوة",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "maghrebi_specific"
      ],
      "variations": [
        "قهوة",
        "kahwa",
        "ga7wa"
      ],
      "case_sensitive": false,
      "context_notes": "Whore (Moroccan spelling) - extremely offensive Maghrebi term. Arabizi: ga7wa",
      "target_type": "individual"
    },
    {
      "word": "كس اختك",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "كس اختك",
        "kess i5tak",
        "kos o5tak"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your sister - extremely offensive family/sexual insult. Arabizi: kess i5tak",
      "target_type": "individual"
    },
    {
      "word": "خنيث",
      "severity": 4,
      "categories": [
        "hate_speech",
        "homophobic",
        "extremely_offensive"
      ],
      "variations": [
        "خنيث",
        "khaneeth",
        "5aneeth"
      ],
      "case_sensitive": false,
      "context_notes": "Gay (extremely derogatory) - severe homophobic slur. Arabizi: 5aneeth",
      "target_type": "individual"
    },
    {
      "word": "خارج",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "خارج",
        "khareg",
        "5areg"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina - Tunisian extremely vulgar anatomical term. Arabizi: 5areg",
      "target_type": "general"
    },
    {
      "word": "كوس",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar"
      ],
      "variations": [
        "كوس",
        "koos",
        "kous"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina (variant spelling) - extremely vulgar anatomical term. Arabizi: koos",
      "target_type": "general"
    },
    {
      "word": "كس",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar"
      ],
      "variations": [
        "كس امك",
        "kus",
        "kos",
        "2os"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia, extremely vulgar, often in compound expressions",
      "target_type": "general"
    },
    {
      "word": "كس امك",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "كسم",
        "kusumak",
        "kus emak",
        "2osomak"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother's vagina, most offensive Arabic insult, taboo",
      "target_type": "individual"
    },
    {
      "word": "منيك",
      "severity": 4,
      "categories": [
        "hate_speech",
        "homophobic",
        "extremely_offensive"
      ],
      "variations": [
        "منيك",
        "manyak",
        "manyik"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - extremely offensive homophobic slur. Arabizi: manyak",
      "target_type": "individual"
    },
    {
      "word": "منيوك",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "passive_insult"
      ],
      "variations": [
        "منيك",
        "manyouk",
        "manyook",
        "mnik"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked (passive), extremely vulgar sexual insult",
      "target_type": "individual"
    },
    {
      "word": "متناك",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "passive_insult"
      ],
      "variations": [
        "متناك",
        "metnaak",
        "metnak",
        "mt7awel"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked (passive) - extremely vulgar sexual insult. Arabizi: metnak",
      "target_type": "individual"
    },
    {
      "word": "نيك",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "verb"
      ],
      "variations": [
        "ينيك",
        "نياك",
        "nik",
        "nayek",
        "nayak"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck (verb), extremely vulgar sexual verb",
      "target_type": "general"
    },
    {
      "word": "نونة",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "نونة",
        "nouna",
        "noona"
      ],
      "case_sensitive": false,
      "context_notes": "Clit - Tunisian extremely vulgar anatomical term. Arabizi: noona",
      "target_type": "general"
    },
    {
      "word": "قحبة",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "قحاب",
        "qa7ba",
        "ga7ba",
        "2a7ba"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitute, extremely offensive term for women, taboo",
      "target_type": "individual"
    },
    {
      "word": "سالغوت",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "maghrebi_specific"
      ],
      "variations": [
        "سالغوت",
        "salgot",
        "salghout"
      ],
      "case_sensitive": false,
      "context_notes": "Slut - Moroccan extremely offensive term for women. Arabizi: salghout",
      "target_type": "individual"
    },
    {
      "word": "شرموطة",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "شرموط",
        "sharmuta",
        "sharmoot",
        "shar6a"
      ],
      "case_sensitive": false,
      "context_notes": "Whore/slut, extremely offensive term for women, severe insult",
      "target_type": "individual"
    },
    {
      "word": "صرم",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "صرم",
        "sorm",
        "9orm"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina - Tunisian extremely vulgar anatomical term. Arabizi: 9orm",
      "target_type": "general"
    },
    {
      "word": "طابون",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "maghrebi_specific"
      ],
      "variations": [
        "طابون",
        "tabon",
        "6aboun"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy - Maghrebi extremely vulgar anatomical term. Arabizi: 6aboun",
      "target_type": "general"
    },
    {
      "word": "يا ابن الشرموطة",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "extremely_vulgar"
      ],
      "variations": [
        "يا ابن الشرموطة",
        "ya ibn el shar6a",
        "ya ebn el sharmouta"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a bitch/whore - extremely offensive compound insult. Arabizi: ya ebn el shar6a",
      "target_type": "individual"
    },
    {
      "word": "يا بن المتناكة",
      "severity": 4,
      "categories": [
        "sexual",
        "family_insult",
        "compound",
        "extremely_vulgar"
      ],
      "variations": [
        "ابن المتناكة",
        "ibn el mitnaka",
        "ebn el mt7awla"
      ],
      "case_sensitive": false,
      "context_notes": "Son of the fucked woman, extremely vulgar compound family insult",
      "target_type": "individual"
    },
    {
      "word": "يا شرموطة",
      "severity": 4,
      "categories": [
        "sexual",
        "female_specific",
        "extremely_vulgar"
      ],
      "variations": [
        "يا شرموطة",
        "ya sharmouta",
        "ya shar6a"
      ],
      "case_sensitive": false,
      "context_notes": "You bitch/whore - extremely offensive to women. Arabizi: ya shar6a",
      "target_type": "individual"
    },
    {
      "word": "زوك",
      "severity": 4,
      "categories": [
        "sexual",
        "anatomical",
        "extremely_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "زوك",
        "zouk",
        "zouc"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina - Tunisian extremely vulgar anatomical term. Arabizi: zouc",
      "target_type": "general"
    },
    {
      "word": "الله ياخدك",
      "severity": 3,
      "categories": [
        "religious",
        "curse",
        "death_wish"
      ],
      "variations": [
        "الله ياخدك",
        "allah ya5odak",
        "allah ya5thek"
      ],
      "case_sensitive": false,
      "context_notes": "May God take your soul - religious death curse. Arabizi: allah ya5odak",
      "target_type": "individual"
    },
    {
      "word": "الله يخرب بيتك",
      "severity": 3,
      "categories": [
        "religious",
        "curse",
        "compound"
      ],
      "variations": [
        "الله يخرب بيتك",
        "allahi ye5rib beytak",
        "allah ye5reb beytak"
      ],
      "case_sensitive": false,
      "context_notes": "God damn you - religious curse invoking divine destruction. Arabizi: allah ye5reb beytak",
      "target_type": "individual"
    },
    {
      "word": "ابن المرة",
      "severity": 3,
      "categories": [
        "family_insult",
        "derogatory",
        "female_specific"
      ],
      "variations": [
        "ابن المرة",
        "ebn el-mara",
        "ibn el-mara"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a bitch - family insult, offensive. Arabizi: ebn el-mara",
      "target_type": "individual"
    },
    {
      "word": "العن ابوك",
      "severity": 3,
      "categories": [
        "religious",
        "family_insult",
        "curse"
      ],
      "variations": [
        "العن ابوك",
        "el3an abook",
        "la3an abuk"
      ],
      "case_sensitive": false,
      "context_notes": "May your father be cursed - family-targeted religious curse. Arabizi: el3an abook",
      "target_type": "individual"
    },
    {
      "word": "غاهبة",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory",
        "maghrebi_specific"
      ],
      "variations": [
        "غاهبة",
        "gahaba",
        "ra7aba"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch - Tunisian offensive term for women. Arabizi: ra7aba",
      "target_type": "individual"
    },
    {
      "word": "ابن كلب",
      "severity": 3,
      "categories": [
        "derogatory",
        "family_insult",
        "compound"
      ],
      "variations": [
        "ولد كلب",
        "ibn kalb",
        "ebn kalb",
        "weld kalb"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a dog, compound insult involving family, highly offensive",
      "target_type": "individual"
    },
    {
      "word": "كاود",
      "severity": 3,
      "categories": [
        "dismissive",
        "vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "كاود",
        "kawed",
        "kaoud"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck off - Moroccan dismissive vulgar term. Arabizi: kaoud",
      "target_type": "individual"
    },
    {
      "word": "خنزير",
      "severity": 3,
      "categories": [
        "derogatory",
        "religious",
        "animal_insult"
      ],
      "variations": [
        "خنازير",
        "khanzeer",
        "5anzeer",
        "5nzeer"
      ],
      "case_sensitive": false,
      "context_notes": "Pig, extremely offensive due to Islamic dietary laws, severe insult",
      "target_type": "individual"
    },
    {
      "word": "خارة",
      "severity": 3,
      "categories": [
        "scatological",
        "vulgar"
      ],
      "variations": [
        "خارة",
        "khara",
        "5ara"
      ],
      "case_sensitive": false,
      "context_notes": "Shit (variant spelling) - scatological vulgar term. Arabizi: 5ara",
      "target_type": "general"
    },
    {
      "word": "خول",
      "severity": 3,
      "categories": [
        "hate_speech",
        "homophobic",
        "derogatory"
      ],
      "variations": [
        "خول",
        "khawal",
        "5awal",
        "khawal"
      ],
      "case_sensitive": false,
      "context_notes": "Gay (derogatory) - homophobic slur, very offensive. Arabizi: 5awal",
      "target_type": "individual"
    },
    {
      "word": "كول خرا",
      "severity": 3,
      "categories": [
        "scatological",
        "command",
        "vulgar"
      ],
      "variations": [
        "كول خرا",
        "kol 5ara",
        "kul khara"
      ],
      "case_sensitive": false,
      "context_notes": "Eat shit - scatological command, very vulgar. Arabizi: kol 5ara",
      "target_type": "individual"
    },
    {
      "word": "لبوة",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory"
      ],
      "variations": [
        "لبوة",
        "labwa",
        "labwa"
      ],
      "case_sensitive": false,
      "context_notes": "Slut - offensive term for women, Egyptian usage. Arabizi: labwa",
      "target_type": "individual"
    },
    {
      "word": "ملحاة",
      "severity": 3,
      "categories": [
        "sexual",
        "female_specific",
        "derogatory",
        "maghrebi_specific"
      ],
      "variations": [
        "ملحاة",
        "malhat",
        "mal7at"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch - Tunisian offensive term for women. Arabizi: mal7at",
      "target_type": "individual"
    },
    {
      "word": "نام",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical",
        "vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "نام",
        "nam",
        "naam"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - Tunisian vulgar anatomical term. Arabizi: naam",
      "target_type": "general"
    },
    {
      "word": "شاذ",
      "severity": 3,
      "categories": [
        "hate_speech",
        "homophobic",
        "derogatory"
      ],
      "variations": [
        "شاذ",
        "shaz",
        "shath",
        "shazz"
      ],
      "case_sensitive": false,
      "context_notes": "Gay (derogatory) - homophobic term, offensive. Arabizi: shazz",
      "target_type": "individual"
    },
    {
      "word": "تلحس طيزي",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical",
        "vulgar"
      ],
      "variations": [
        "تلحس طيزي",
        "tel7as teezi",
        "tel7as 6eezi"
      ],
      "case_sensitive": false,
      "context_notes": "Kiss my ass - vulgar Levantine insult. Arabizi: tel7as 6eezi",
      "target_type": "individual"
    },
    {
      "word": "ولد الكلاب",
      "severity": 3,
      "categories": [
        "derogatory",
        "family_insult",
        "compound"
      ],
      "variations": [
        "ولد الكلاب",
        "wald il klaab",
        "walad el klaab"
      ],
      "case_sensitive": false,
      "context_notes": "Son of dogs - compound family insult, plural form. Arabizi: walad el klaab",
      "target_type": "individual"
    },
    {
      "word": "يا خرا",
      "severity": 3,
      "categories": [
        "scatological",
        "direct_address",
        "vulgar"
      ],
      "variations": [
        "خرا",
        "khara",
        "5ara",
        "ya 5ara"
      ],
      "case_sensitive": false,
      "context_notes": "You shit, direct scatological insult, very vulgar",
      "target_type": "individual"
    },
    {
      "word": "يخسف الله به الأرض",
      "severity": 3,
      "categories": [
        "religious",
        "curse",
        "compound"
      ],
      "variations": [
        "يخسف الله به الأرض",
        "ya5saf allah bih al2ard"
      ],
      "case_sensitive": false,
      "context_notes": "May God swallow the Earth beneath you - elaborate religious curse. Arabizi: ya5saf allah bih al2ard",
      "target_type": "individual"
    },
    {
      "word": "يلعن ابوك",
      "severity": 3,
      "categories": [
        "religious",
        "family_insult",
        "curse"
      ],
      "variations": [
        "لعن ابوك",
        "yel3an abuk",
        "la3n abuk"
      ],
      "case_sensitive": false,
      "context_notes": "Curse your father, religious curse involving family, very offensive",
      "target_type": "individual"
    },
    {
      "word": "زبي",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical",
        "vulgar"
      ],
      "variations": [
        "زب",
        "zabb",
        "zabbi",
        "zob"
      ],
      "case_sensitive": false,
      "context_notes": "My penis, vulgar anatomical reference, common in Levantine",
      "target_type": "general"
    },
    {
      "word": "زامل",
      "severity": 3,
      "categories": [
        "hate_speech",
        "homophobic",
        "maghrebi_specific"
      ],
      "variations": [
        "زامل",
        "zamel",
        "zaml"
      ],
      "case_sensitive": false,
      "context_notes": "Gay (derogatory) - Maghrebi homophobic slur. Arabizi: zamel",
      "target_type": "individual"
    },
    {
      "word": "زوب",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomical",
        "maghrebi_specific"
      ],
      "variations": [
        "زوب",
        "zob",
        "zoub"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - Maghrebi vulgar anatomical term. Arabizi: zoub",
      "target_type": "general"
    },
    {
      "word": "عرص",
      "severity": 2,
      "categories": [
        "derogatory",
        "general",
        "egyptian_specific"
      ],
      "variations": [
        "عروص",
        "3ars",
        "3ros",
        "3aars"
      ],
      "case_sensitive": false,
      "context_notes": "Pimp, Egyptian-specific insult, implies immoral behavior",
      "target_type": "individual"
    },
    {
      "word": "احمق",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence",
        "traditional"
      ],
      "variations": [
        "حمقاء",
        "a7maq",
        "7amaq",
        "a7ma2"
      ],
      "case_sensitive": false,
      "context_notes": "Fool/idiot, traditional insult implying lack of wisdom",
      "target_type": "individual"
    },
    {
      "word": "ابو ريحة",
      "severity": 2,
      "categories": [
        "derogatory",
        "cleanliness",
        "levantine_specific"
      ],
      "variations": [
        "ابو ريحة",
        "abu reiha",
        "abu ree7a"
      ],
      "case_sensitive": false,
      "context_notes": "Father of stinky smells - Levantine insult implying uncleanliness. Arabizi: abu ree7a",
      "target_type": "individual"
    },
    {
      "word": "عايل متسول",
      "severity": 2,
      "categories": [
        "derogatory",
        "classist",
        "egyptian_specific"
      ],
      "variations": [
        "عايل متسول",
        "ayel motasawel",
        "3ayel metsa7el"
      ],
      "case_sensitive": false,
      "context_notes": "You're a ghetto/beggar - classist Egyptian insult. Arabizi: 3ayel metsa7el",
      "target_type": "individual"
    },
    {
      "word": "بعبوص",
      "severity": 2,
      "categories": [
        "gesture",
        "derogatory",
        "egyptian_specific"
      ],
      "variations": [
        "بعبوص",
        "baa'boos",
        "ba3boos"
      ],
      "case_sensitive": false,
      "context_notes": "Middle finger gesture - Egyptian term for obscene gesture. Arabizi: ba3boos",
      "target_type": "general"
    },
    {
      "word": "بهيم",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "general"
      ],
      "variations": [
        "بهيم",
        "baheem",
        "ba7eem"
      ],
      "case_sensitive": false,
      "context_notes": "Beast (masculine) - common animal insult across dialects. Arabizi: ba7eem",
      "target_type": "individual"
    },
    {
      "word": "بهيمة",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "general",
        "female_specific"
      ],
      "variations": [
        "بهيمة",
        "baheema",
        "ba7eema"
      ],
      "case_sensitive": false,
      "context_notes": "Beast (feminine) - common animal insult across dialects. Arabizi: ba7eema",
      "target_type": "individual"
    },
    {
      "word": "بيدان",
      "severity": 2,
      "categories": [
        "anatomical",
        "vulgar",
        "egyptian_specific"
      ],
      "variations": [
        "بيدان",
        "bedan",
        "beedan"
      ],
      "case_sensitive": false,
      "context_notes": "Balls (testicles) - vulgar anatomical term. Arabizi: beedan",
      "target_type": "general"
    },
    {
      "word": "دنيء",
      "severity": 2,
      "categories": [
        "derogatory",
        "moral",
        "formal"
      ],
      "variations": [
        "دنيء",
        "danee'",
        "danee2"
      ],
      "case_sensitive": false,
      "context_notes": "Vile - MSA formal moral insult. Arabizi: danee2",
      "target_type": "individual"
    },
    {
      "word": "فاسق",
      "severity": 2,
      "categories": [
        "derogatory",
        "religious",
        "moral"
      ],
      "variations": [
        "فاسق",
        "fasiq",
        "fasi2"
      ],
      "case_sensitive": false,
      "context_notes": "Sinner/immoral - MSA religious/moral insult. Arabizi: fasi2",
      "target_type": "individual"
    },
    {
      "word": "حقير",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "gulf_specific"
      ],
      "variations": [
        "حقير",
        "haqeer",
        "7a2eer"
      ],
      "case_sensitive": false,
      "context_notes": "Beast/Brute - Gulf insult, moderate severity. Arabizi: 7a2eer",
      "target_type": "individual"
    },
    {
      "word": "حمار",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence",
        "animal_insult"
      ],
      "variations": [
        "حمير",
        "himar",
        "7mar",
        "7amaar"
      ],
      "case_sensitive": false,
      "context_notes": "Donkey, implies stupidity, widely used across Arabic dialects",
      "target_type": "individual"
    },
    {
      "word": "ابن الجزمة",
      "severity": 2,
      "categories": [
        "derogatory",
        "family_insult",
        "egyptian_specific"
      ],
      "variations": [
        "ابن الجزمة",
        "ibn el gazma",
        "ebn el gazma"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a shoe - Egyptian compound family insult. Arabizi: ebn el gazma",
      "target_type": "individual"
    },
    {
      "word": "ابن الحمار",
      "severity": 2,
      "categories": [
        "derogatory",
        "family_insult",
        "animal_insult"
      ],
      "variations": [
        "ابن الحمار",
        "ibn il-7mar",
        "ebn el 7omar"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a donkey - compound family insult implying stupidity. Arabizi: ebn el 7omar",
      "target_type": "individual"
    },
    {
      "word": "كلب",
      "severity": 2,
      "categories": [
        "derogatory",
        "general",
        "animal_insult"
      ],
      "variations": [
        "كلاب",
        "كليب",
        "kalb",
        "kelb",
        "2alb"
      ],
      "case_sensitive": false,
      "context_notes": "Dog, common insult across all Arabic dialects, moderate offense",
      "target_type": "individual"
    },
    {
      "word": "لعنة",
      "severity": 2,
      "categories": [
        "religious",
        "curse",
        "general"
      ],
      "variations": [
        "لعنة الله",
        "la'na",
        "l3na",
        "lan3a"
      ],
      "case_sensitive": false,
      "context_notes": "Curse, religious profanity involving divine condemnation",
      "target_type": "general"
    },
    {
      "word": "مخه زي الجزمة",
      "severity": 2,
      "categories": [
        "derogatory",
        "intelligence",
        "egyptian_specific"
      ],
      "variations": [
        "مخه زي الجزمة",
        "moxxu gazma",
        "mo55o zay el gazma"
      ],
      "case_sensitive": false,
      "context_notes": "His mind is like a shoe - Egyptian insult implying stupidity. Arabizi: mo55o zay el gazma",
      "target_type": "individual"
    },
    {
      "word": "مشرمل",
      "severity": 2,
      "categories": [
        "derogatory",
        "moral",
        "maghrebi_specific"
      ],
      "variations": [
        "مشرمل",
        "msharml",
        "msharmel"
      ],
      "case_sensitive": false,
      "context_notes": "Shameless (masculine) - Moroccan moral insult. Arabizi: msharmel",
      "target_type": "individual"
    },
    {
      "word": "مشرملة",
      "severity": 2,
      "categories": [
        "derogatory",
        "moral",
        "maghrebi_specific",
        "female_specific"
      ],
      "variations": [
        "مشرملة",
        "msharmla",
        "msharmela"
      ],
      "case_sensitive": false,
      "context_notes": "Shameless (feminine) - Moroccan moral insult. Arabizi: msharmela",
      "target_type": "individual"
    },
    {
      "word": "قليل الأدب",
      "severity": 2,
      "categories": [
        "derogatory",
        "formal",
        "moral"
      ],
      "variations": [
        "قليل الأدب",
        "2aleel al2adab",
        "qaleel aladab"
      ],
      "case_sensitive": false,
      "context_notes": "Of little literature/manners - formal MSA insult. Arabizi: 2aleel al2adab",
      "target_type": "individual"
    },
    {
      "word": "صافي نتا حمار",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "maghrebi_specific"
      ],
      "variations": [
        "صافي نتا حمار",
        "safi nta 7mar",
        "9afi nta 7mar"
      ],
      "case_sensitive": false,
      "context_notes": "Enough, you're a donkey - Moroccan compound insult. Arabizi: 9afi nta 7mar",
      "target_type": "individual"
    },
    {
      "word": "سافل",
      "severity": 2,
      "categories": [
        "derogatory",
        "moral",
        "formal"
      ],
      "variations": [
        "سافل",
        "safil",
        "safil"
      ],
      "case_sensitive": false,
      "context_notes": "Low/base - MSA formal moral insult. Arabizi: safil",
      "target_type": "individual"
    },
    {
      "word": "سووا",
      "severity": 2,
      "categories": [
        "anatomical",
        "mild_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "سووا",
        "soowa",
        "souwa"
      ],
      "case_sensitive": false,
      "context_notes": "Ass - Maghrebi anatomical term. Arabizi: souwa",
      "target_type": "general"
    },
    {
      "word": "طه حضرتك",
      "severity": 2,
      "categories": [
        "curse",
        "levantine_specific"
      ],
      "variations": [
        "طه حضرتك",
        "tah-hathek",
        "6ah 7a6rek"
      ],
      "case_sensitive": false,
      "context_notes": "May all your luck be taken away - Levantine curse. Arabizi: 6ah 7a6rek",
      "target_type": "individual"
    },
    {
      "word": "تيس",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "gulf_specific"
      ],
      "variations": [
        "تيس",
        "tays",
        "6ays"
      ],
      "case_sensitive": false,
      "context_notes": "Goat - Gulf animal insult, implies stubbornness. Arabizi: 6ays",
      "target_type": "individual"
    },
    {
      "word": "تيز",
      "severity": 2,
      "categories": [
        "anatomical",
        "mild_vulgar"
      ],
      "variations": [
        "طيز",
        "teez",
        "6eez",
        "tiz"
      ],
      "case_sensitive": false,
      "context_notes": "Buttocks/ass, mildly vulgar, common in casual speech",
      "target_type": "general"
    },
    {
      "word": "طز فيك",
      "severity": 2,
      "categories": [
        "derogatory",
        "dismissive",
        "general"
      ],
      "variations": [
        "طز فيك",
        "tozz feek",
        "6ozz feek",
        "toz fik"
      ],
      "case_sensitive": false,
      "context_notes": "Screw you - dismissive insult, moderate severity. Arabizi: 6ozz feek",
      "target_type": "individual"
    },
    {
      "word": "وسخ",
      "severity": 2,
      "categories": [
        "derogatory",
        "cleanliness",
        "general"
      ],
      "variations": [
        "وسخة",
        "wisikh",
        "weskh",
        "wsa5"
      ],
      "case_sensitive": false,
      "context_notes": "Dirty/filthy, implies moral or physical uncleanliness",
      "target_type": "individual"
    },
    {
      "word": "يا جزمة",
      "severity": 2,
      "categories": [
        "derogatory",
        "general",
        "egyptian_specific"
      ],
      "variations": [
        "جزمة",
        "ya gazma",
        "ya gazma",
        "gazma"
      ],
      "case_sensitive": false,
      "context_notes": "You shoe - uniquely Egyptian insult, implies worthlessness. Arabizi: ya gazma",
      "target_type": "individual"
    },
    {
      "word": "يا حيوان",
      "severity": 2,
      "categories": [
        "derogatory",
        "animal_insult",
        "general"
      ],
      "variations": [
        "حيوان",
        "ya hayawan",
        "ya 7ayawan",
        "hayawan"
      ],
      "case_sensitive": false,
      "context_notes": "You animal - common insult across dialects. Arabizi: ya 7ayawan",
      "target_type": "individual"
    },
    {
      "word": "يخرب بيتك",
      "severity": 2,
      "categories": [
        "religious",
        "curse",
        "egyptian_specific"
      ],
      "variations": [
        "يخرب بيتك",
        "yixrib beitak",
        "ye5rab beytak"
      ],
      "case_sensitive": false,
      "context_notes": "May God destroy your house - Egyptian curse, moderate severity. Arabizi: ye5rab beytak",
      "target_type": "individual"
    },
    {
      "word": "زاكة",
      "severity": 2,
      "categories": [
        "anatomical",
        "mild_vulgar",
        "maghrebi_specific"
      ],
      "variations": [
        "زاكة",
        "zaaka",
        "zaka"
      ],
      "case_sensitive": false,
      "context_notes": "Ass - Tunisian anatomical term. Arabizi: zaka",
      "target_type": "general"
    },
    {
      "word": "زفت",
      "severity": 2,
      "categories": [
        "scatological",
        "derogatory",
        "general"
      ],
      "variations": [
        "زفت",
        "zift",
        "zeft"
      ],
      "case_sensitive": false,
      "context_notes": "Tar/crap - scatological insult, moderate severity. Arabizi: zeft",
      "target_type": "general"
    },
    {
      "word": "أهبل",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild"
      ],
      "variations": [
        "أهبل",
        "ahbal",
        "2ahbal",
        "ahbal"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid/crazy - mild Egyptian insult. Arabizi: 2ahbal",
      "target_type": "individual"
    },
    {
      "word": "أجدب",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild",
        "gulf_specific"
      ],
      "variations": [
        "أجدب",
        "ajdab",
        "2ajdab"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot - Gulf mild insult. Arabizi: 2ajdab",
      "target_type": "individual"
    },
    {
      "word": "العمى",
      "severity": 1,
      "categories": [
        "exclamation",
        "mild",
        "levantine_specific"
      ],
      "variations": [
        "العمى",
        "al'ama",
        "al3ama"
      ],
      "case_sensitive": false,
      "context_notes": "Blindness/Damn - Levantine exclamation, mild curse. Arabizi: al3ama",
      "target_type": "general"
    },
    {
      "word": "بخيل",
      "severity": 1,
      "categories": [
        "derogatory",
        "character",
        "mild"
      ],
      "variations": [
        "بخيل",
        "bakheel",
        "ba5eel"
      ],
      "case_sensitive": false,
      "context_notes": "Stingy - MSA character insult, mild severity. Arabizi: ba5eel",
      "target_type": "individual"
    },
    {
      "word": "بليد",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild"
      ],
      "variations": [
        "بليد",
        "baleed",
        "baleed"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid/Dull - Gulf mild insult about intelligence. Arabizi: baleed",
      "target_type": "individual"
    },
    {
      "word": "فصيل",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild",
        "egyptian_specific"
      ],
      "variations": [
        "فصيل",
        "faseel",
        "fa9eel"
      ],
      "case_sensitive": false,
      "context_notes": "Buzz killer - Egyptian slang for annoying person. Arabizi: fa9eel",
      "target_type": "individual"
    },
    {
      "word": "غبية",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild",
        "female_specific"
      ],
      "variations": [
        "غبية",
        "ghabeyya",
        "rabeya",
        "3abeyya"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid (feminine form) - mild insult. Arabizi: 3abeyya",
      "target_type": "individual"
    },
    {
      "word": "غبي",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild"
      ],
      "variations": [
        "غبية",
        "ghabi",
        "rabi",
        "3abi"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid, mild insult questioning intelligence",
      "target_type": "individual"
    },
    {
      "word": "جاهل",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild"
      ],
      "variations": [
        "جاهل",
        "jahil",
        "ja7el"
      ],
      "case_sensitive": false,
      "context_notes": "Ignorant - MSA mild insult about knowledge. Arabizi: ja7el",
      "target_type": "individual"
    },
    {
      "word": "كاذب",
      "severity": 1,
      "categories": [
        "derogatory",
        "character",
        "mild"
      ],
      "variations": [
        "كاذب",
        "kathib",
        "kazib"
      ],
      "case_sensitive": false,
      "context_notes": "Liar - MSA character insult, mild severity. Arabizi: kazib",
      "target_type": "individual"
    },
    {
      "word": "مجنون",
      "severity": 1,
      "categories": [
        "derogatory",
        "mental",
        "mild"
      ],
      "variations": [
        "مجنون",
        "majnoon",
        "majnoun"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy - MSA mild insult implying mental instability. Arabizi: majnoun",
      "target_type": "individual"
    },
    {
      "word": "متعب",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild",
        "general"
      ],
      "variations": [
        "متعب",
        "mota3eb",
        "met3eb"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying (masculine) - mild complaint. Arabizi: met3eb",
      "target_type": "individual"
    },
    {
      "word": "متعبة",
      "severity": 1,
      "categories": [
        "derogatory",
        "mild",
        "general",
        "female_specific"
      ],
      "variations": [
        "متعبة",
        "mota3eba",
        "met3eba"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying (feminine) - mild complaint. Arabizi: met3eba",
      "target_type": "individual"
    },
    {
      "word": "سطل",
      "severity": 1,
      "categories": [
        "derogatory",
        "intelligence",
        "mild",
        "gulf_specific"
      ],
      "variations": [
        "سطل",
        "satal",
        "sa6al"
      ],
      "case_sensitive": false,
      "context_notes": "Fool - Gulf mild insult. Arabizi: sa6al",
      "target_type": "individual"
    },
    {
      "word": "يا خرابي",
      "severity": 1,
      "categories": [
        "exclamation",
        "mild",
        "egyptian_specific"
      ],
      "variations": [
        "يا خرابي",
        "ya kharabi",
        "ya 5arabi"
      ],
      "case_sensitive": false,
      "context_notes": "Damn it! - Egyptian exclamation, mild frustration. Arabizi: ya 5arabi",
      "target_type": "general"
    }
  ]
} as const

export type ARType = typeof AR
